"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;
require("core-js/modules/web.dom.iterable");
var _auth = require("@/utils/auth");
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
// import { JSEncrypt } from 'jsencrypt'
var _default = exports.default = {
  name: 'Login',
  data: function data() {
    var _this = this;
    var validateUsername = function validateUsername(rule, value, callback) {
      if (value.length < 1) {
        callback(new Error(_this.$t('login.error.username')));
      } else if (_this.errorKeys.indexOf('loginCode') >= 0) {
        callback(new Error(_this.errorInfo['loginCode']));
      } else {
        callback();
      }
    };
    var validatePassword = function validatePassword(rule, value, callback) {
      if (!value || value.length < 6) {
        callback(new Error(_this.$t('login.error.password')));
      } else if (_this.errorKeys.indexOf('loginPass') >= 0) {
        callback(new Error(_this.errorInfo['loginPass']));
      } else {
        callback();
      }
    };
    return {
      loginForm: {
        username: '',
        password: ''
      },
      loginRules: {
        username: [{
          required: false,
          trigger: ['change'],
          validator: validateUsername
        }],
        password: [{
          required: false,
          trigger: ['change'],
          validator: validatePassword
        }]
      },
      errorKeys: [],
      errorInfo: {},
      passwordType: 'password',
      identifyCodes: '0123456789',
      isRemember: '',
      loading: false
    };
  },
  mounted: function mounted() {
    this.eventInit();
  },
  methods: {
    eventInit: function eventInit() {
      // focus当前输入项
      if (this.loginForm.username === '') {
        this.$refs.username.focus();
      } else if (this.loginForm.password === '') {
        this.$refs.password.focus();
      }
      // 确认并获取账号密码状态
      this.isRemember = localStorage.getItem('isRemember') ? localStorage.getItem('isRemember') : '';
      if (this.isRemember) {
        this.loginForm.username = localStorage.getItem('username') ? localStorage.getItem('username') : '';
        this.loginForm.password = localStorage.getItem('password') ? this.decryptStr(localStorage.getItem('password'), 'local') : '';
      }
    },
    showPwd: function showPwd() {
      var _this2 = this;
      if (this.passwordType === 'password') {
        this.passwordType = '';
      } else {
        this.passwordType = 'password';
      }
      this.$nextTick(function () {
        _this2.$refs.password.focus();
      });
    },
    clickRadio: function clickRadio() {
      this.isRemember = this.isRemember ? '' : 'y';
    },
    encryptStr: function encryptStr(password) {
      var type = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : 'login';
      var NodeRSA = require('node-rsa');
      var a_public_key_data = type === 'login' ? process.env.VUE_APP_PUBLIC_KEY : process.env.VUE_APP_PWD_PUB_KEY;
      var key = new NodeRSA();
      key.setOptions({
        encryptionScheme: 'pkcs1'
      });
      key.importKey(a_public_key_data, 'pkcs8-public');
      var x = key.encrypt(password, 'base64');
      return x;
    },
    decryptStr: function decryptStr(password) {
      var type = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : 'login';
      var NodeRSA = require('node-rsa');
      var a_private_key_data = type === 'login' ? process.env.VUE_APP_PRIVATE_KEY : process.env.VUE_APP_PWD_PRI_KEY;
      var key2 = new NodeRSA();
      key2.setOptions({
        encryptionScheme: 'pkcs1'
      });
      key2.importKey(a_private_key_data, 'pkcs8-private');
      var y = key2.decrypt(password, 'utf8');
      return y;
    },
    handleLogin: function handleLogin() {
      var _this3 = this;
      this.errorKeys = [];
      this.errorInfo = {};
      this.$refs['loginForm'].clearValidate();
      this.$refs.loginForm.validate(function (valid) {
        if (!valid) return;
        _this3.loading = true;
        var _this3$loginForm = _this3.loginForm,
          username = _this3$loginForm.username,
          password = _this3$loginForm.password;
        console.log(username, password);
        // const data = { loginCode: username.trim(), loginPass: password }
        // const encData = {
        //   sdata: this.encryptStr(data)
        // }
        _this3.$api.login.getAuthToken({
          loginCode: username.trim(),
          loginPass: password
        })
        // this.$api.login.getAuthToken(encData)
        .then(function (res) {
          localStorage.setItem('isRemember', _this3.isRemember);
          if (_this3.isRemember) {
            localStorage.setItem('username', username);
            localStorage.setItem('password', _this3.encryptStr(password, 'local'));
          } else {
            localStorage.removeItem('username');
            localStorage.removeItem('password');
          }
          _this3.$store.dispatch('user/setToken', res.data.token);
          _this3.$store.dispatch('user/setInfo', res.data.currUser);
          _this3.$store.dispatch('user/setSystemList', res.data.systemInfos);
          if (res.data.systemInfos.length === 1) {
            _this3.currentSystem = res.data.systemInfos[0];
            _this3.singleSystemLogin(res.data.systemInfos[0].appIdentification);
          } else {
            setTimeout(function () {
              _this3.$router.push({
                path: '/system'
              });
              _this3.loading = false;
            }, 200);
          }
        }).catch(function (err) {
          if (err.errorInfos && err.errorInfos.length > 0) {
            err.errorInfos.forEach(function (item) {
              _this3.errorKeys.push(item.key);
              _this3.errorInfo[item.key] = item.errMsg;
            });
            _this3.$refs['loginForm'].validate(function (valid) {});
          }
          _this3.loading = false;
        });
      });
    },
    singleSystemLogin: function singleSystemLogin(systemId) {
      var _this4 = this;
      this.$api.login.getUserInfo(systemId).then(function (res) {
        _this4.$store.dispatch('user/setCurrentSystemInfo', _this4.currentSystem);
        _this4.$store.dispatch('nocache/setAddRoute', {
          isAddRoute: true
        });
        _this4.$store.dispatch('permission/generateRoutes', res.data.menus).then(function (res) {
          _this4.$router.push({
            path: '/dashboard'
          });
          _this4.loading = false;
        });
        _this4.$store.dispatch('permission/generateFunctions', res.data.functions);
      }).catch(function () {
        (0, _auth.removeToken)();
        _this4.loading = false;
      });
    }
  }
};